import { NetbankingAPI } from "aaa";
import { action, computed, observable } from "mobx";
import { IIdentificationNew, IProfile } from "types/profile";
import { NetbankingAPIClient } from "network/APIClient";

export class ProfileStore {
    @observable profile?: IProfile;
    @observable identification?: IIdentificationNew;

    @observable isLoadingProfile: boolean = false;
    @observable isLoadingIdentification: boolean = false;
    @computed get isLoading() { return this.isLoadingProfile || this.isLoadingIdentification; }

    @computed get name(): string {
        return this.profile ? `${this.profile.firstname} ${this.profile.lastname}` : "";
    }

    @action async load() {
        const target = NetbankingAPI.getProfile();
        this.isLoadingProfile = true;

        try {
            this.profile = await NetbankingAPIClient.requestType(target);
            this.isLoadingProfile = false;
        } catch (error) {
            this.isLoadingProfile = false;
            throw error;
        }
    }

    @action async loadIdentification() {
        const target = NetbankingAPI.getProfileIdentificationNew();
        this.isLoadingIdentification = true;

        try {
            this.identification = await NetbankingAPIClient.requestType(target);
            this.isLoadingIdentification = false;
        } catch (error) {
            this.isLoadingIdentification = false;
            throw error;
        }
    }
}

const profileStore = new ProfileStore();
export default profileStore;


// WEBPACK FOOTER //
// ./src/stores/ProfileStore.ts